import React, { useEffect, useState } from 'react'
import { FaCheck, FaChevronLeft, FaStar, FaStarHalf, FaUser } from 'react-icons/fa'
import { Avatar, Card, Col, Pagination, Row, Tooltip } from 'antd'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import useQuoteApi from '../../../../config/hooks/api/booking/quote/useQuoteApi'
import { setAppLoading } from '../../../../store/common/generalSlice'
import { getEllipsedString, getInitials, getServicesList } from '../../../../config/utils'
import useWindowSize from '../../../../config/hooks/utility/useWindowSize'
import ChatModal from '../../../Common/Chats/ChatModal'

const ReceivedQuotes = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { requestId } = useParams()
    const { width } = useWindowSize();
    const { getQuotesReceivedForJobRequest } = useQuoteApi()

    const [receivedQuotes, setReceivedQuotes] = useState([])
    const [offset, setOffset] = useState(0)
    const [pageSize, setPageSize] = useState(5)
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0)
    const [spServices, setSpServices] = useState([])


    const getReceivedQuotes = async (jobRequestId) => {
        try {
            dispatch(setAppLoading(true))

            const response = await getQuotesReceivedForJobRequest(jobRequestId, pageSize, offset) //reqid, limit, offset
            const records = response?.data?.quote?.rows;
            if (response) {
                setReceivedQuotes(records);
                let tempServicesArr = [];
                records.forEach(record => {
                    if (record?.user?.services?.length > 0) {
                        tempServicesArr = [...record?.user?.services?.filter(service => service?.parentId == null)]
                    }
                });
                setSpServices(tempServicesArr)
                setTotalItems(response?.data?.quote?.count)
                setOffset(offset + pageSize)
                dispatch(setAppLoading(false))
            }
        } catch (error) {
            console.log(error)
            dispatch(setAppLoading(false))
        }
    }
    
    const handleDecision = (quoteId) => {
        try {
            navigate(`/quote/${quoteId}`)
        } catch (error) {
            console.log(error)
        }
    }

    const onShowSizeChange = (current, pageSize) => {
        setPageSize(pageSize)
    };

    const onPageChange = (page) => {
        setCurrentPage(page)
        setOffset((page - 1) * pageSize)
    };

    useEffect(() => {
        if (requestId) getReceivedQuotes(requestId)
    }, [requestId, currentPage, pageSize])

    return (
        <Row>
            <Col md={24} sm={24} xs={24} className='md:px-20 sm:px-20 md:pt-6 sm:pt-6 px-2 pt-6'>
                <div className='flex justify-between items-center'>
                    <h5 className='heading-5 text-slate-600 font-semibold'>Received Quotes</h5>
                    <Link to='/' className='cursor-pointer flex items-center'>
                        <FaChevronLeft className='text-primary bg-white p-2 rounded-full text-3xl' />
                        <small className='ml-2 font-medium'>Back</small>
                    </Link>
                </div>
            </Col>
            <Col span={24} className='md:px-20 sm:px-20 md:pt-6 sm:pt-6 px-2 pt-6'>
                {
                    receivedQuotes && receivedQuotes.length ?
                        receivedQuotes?.map(quote => {
                            let servicesLength = quote?.services?.length || 0;
                            return (
                                <Card
                                    bordered={false}
                                    className='mb-4 rounded-md'
                                    key={quote?.id}
                                >
                                    <div className='flex lg:flex-row flex-col justify-between'>
                                        <div className='flex sm:flex-row flex-col sm:items-start items-center sm:mb-1 mb-4'>
                                            <div className='flex sm:flex-row flex-col mb-4'>
                                                <Avatar
                                                    className='border-2 p-1 mb-2 border-primary rounded-full'
                                                    src={quote?.user?.imageThumbUrl}
                                                    alt="avatar"
                                                    size={width > 767 ? 100 : 120}
                                                >
                                                    {getInitials(quote?.user?.userDetail?.businessName)}
                                                </Avatar>
                                            </div>
                                            <div className='flex flex-col sm:ml-4  w-full'>
                                                <div className='sm:mb-4 mb-6 ml-1'>
                                                    <div className='flex justify-center sm:justify-start'>
                                                        <h3 className='text-center md:text-left heading-3 font-bold mb-1'>
                                                            {getEllipsedString(quote?.user?.userDetail?.businessName, 15)}
                                                        </h3>

                                                        {
                                                            quote?.user?.badges &&
                                                                quote?.user?.badges.length ? (
                                                                <div className='ml-2 flex justify-center sm:w-[50px]'>
                                                                    {quote?.user?.badges.map(badge => (
                                                                        <img
                                                                            key={badge?.id}
                                                                            src={badge?.imageUrl}
                                                                            alt={badge?.name}
                                                                            className='img-fluid mr-2 h-[30px]'
                                                                            onError={(e) => { e.target.style.display = 'none' }}
                                                                        />
                                                                    ))}
                                                                </div>
                                                            )
                                                                : ''}
                                                    </div>
                                                    {/* <div className='flex justify-center sm:justify-start'>
                                                        {
                                                            quote?.services &&
                                                                quote?.services.length ? (
                                                                <React.Fragment>
                                                                    {quote?.services.slice(0, 3).map((service, index) => (
                                                                        <span key={service?.id}>
                                                                            <p className='text-gray-500 font-semibold text-xs mb-3' >
                                                                                {service?.name}

                                                                                {index < quote?.services.slice(0, 3).length - 1 &&
                                                                                    (<span className='mx-1'>|</span>)}
                                                                                {index == 2 && quote?.services.length > 3 ?
                                                                                    (<span className='mr-1'>...</span>) : ''}
                                                                            </p>
                                                                        </span>
                                                                    ))}
                                                                    {quote?.services?.length > 3 ? (
                                                                        <Tooltip title={getServicesList(quote?.services)}>
                                                                            <p className='text-xs ml-2 cursor-pointer'>show all</p>
                                                                        </Tooltip>
                                                                    ) : ''}
                                                                </React.Fragment>
                                                            ) : (
                                                                <small className='text-xs'>Services not available</small>
                                                            )}
                                                    </div> */}
                                                    <div className='flex justify-center sm:justify-start'>
                                                        {
                                                            quote?.user?.services &&
                                                                quote?.user?.services?.length > 0 ? (
                                                                <React.Fragment>
                                                                    {
                                                                        quote?.user?.services?.filter(service => service?.parentId == null)?.slice(0, 3)?.map((service) => {
                                                                            return (
                                                                                <span className='flex gap-1 items-center' key={service?.id}>
                                                                                    <p className='text-gray-500 font-semibold text-xs mb-3'>
                                                                                        {service?.name + ','}
                                                                                    </p>
                                                                                </span>
                                                                            )
                                                                        })
                                                                    }
                                                                    {quote?.user?.services?.length > 3 && <span>...</span>}
                                                                    {quote?.user?.services?.length > 3 &&
                                                                        (
                                                                            <Tooltip title={getServicesList(quote?.user?.services?.filter(service => service?.parentId == null) || [], false)}>
                                                                                <p className='text-xs ml-2 cursor-pointer'>show all</p>
                                                                            </Tooltip>
                                                                        )
                                                                    }
                                                                </React.Fragment>
                                                            ) : (
                                                                <small className='text-xs'>Services not available</small>
                                                            )
                                                        }
                                                    </div>

                                                    <div className='flex flex-col gap-1'>
                                                        <p className='text-xs text-black text-center md:text-left'>Requested Services:</p>
                                                        <div className='flex justify-center sm:justify-start'>
                                                            {
                                                                quote?.services &&
                                                                    quote?.services.length ? (
                                                                    <React.Fragment>
                                                                        {
                                                                            quote?.services?.slice(0, 3)?.map((service) => {
                                                                                if (service?.name) {
                                                                                    return (
                                                                                        <span className='flex gap-1 items-center justify-start' key={service?.id}>
                                                                                            <p className='text-black text-xs mb-3 w-fit'>
                                                                                                {service?.name + ','}
                                                                                            </p>
                                                                                        </span>
                                                                                    )
                                                                                }
                                                                            })
                                                                        }
                                                                        {quote?.services?.length > 3 && <span>...</span>}
                                                                        {quote?.services?.length > 3 &&
                                                                            (
                                                                                <Tooltip title={getServicesList(quote?.services, false)}>
                                                                                    <p className='text-xs ml-2 cursor-pointer'>show all</p>
                                                                                </Tooltip>
                                                                            )}
                                                                    </React.Fragment>
                                                                ) : (
                                                                    <small className='text-xs'>Services not available</small>
                                                                )}
                                                        </div>
                                                    </div>
                                                    <p className='text-xs sm:text-left text-center'>{quote?.additionalInfo}</p>
                                                </div>
                                                <div className='flex sm:flex-row flex-col flex-wrap'>
                                                    <div className='ratings sm:mr-2 mr-0 mb-2 bg-slate-100 flex rounded-md justify-center items-center p-2'>
                                                        <span className='mr-2 font-bold'>
                                                            {Math.floor(quote?.user?.averageRating)}/5
                                                        </span>

                                                        {/* rated stars count */}
                                                        {
                                                            Array(Math.floor(quote?.user?.averageRating))
                                                                .fill(0).map((el, index) => (
                                                                    <FaStar key={index} className='text-primary' />
                                                                ))
                                                        }
                                                        {
                                                            quote?.user?.ratingCount - Math.floor(quote?.user?.ratingCount) != 0 &&
                                                            (<FaStarHalf className='text-primary' />)
                                                        }

                                                        {/* unrated stars count */}
                                                        {
                                                            Array(5 - Math.floor(quote?.user?.averageRating))
                                                                .fill(0).map((el, index) => (
                                                                    <FaStar key={index} className='text-gray-400' />
                                                                ))
                                                        }
                                                    </div>
                                                    <div
                                                        className='flex justify-center items-center rounded-md bg-[#02B563] cursor-pointer sm:mr-2 mr-0 mb-2 p-2'
                                                        onClick={() => navigate(`/reviews/${quote?.serviceProviderId}`)}
                                                    >
                                                        <small className='text-xs text-white'>Reviews</small>
                                                    </div>
                                                    <Link to={`/profile/${quote?.user?.id}`}>
                                                        <div className='flex justify-center items-center rounded-md bg-[#3879f0] cursor-pointer sm:mr-2 mr-0 mb-2 p-2'>
                                                            <FaUser className='text-white bg-[#6698f3] rounded-full p-[5px] text-2xl' />
                                                            <small className='text-xs text-white ml-2'>View Profile</small>
                                                        </div>
                                                    </Link>
                                                    <div className='sm:mr-2 mr-0 mb-2 p-2 bg-[#feedbf] rounded-md'>
                                                        <ChatModal selectedChatMemberData={quote?.user} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='flex sm:flex-row flex-col justify-around'>
                                            <div className='flex flex-col justify-start sm:border-r sm:border-l sm:border-slate-100 sm:px-4'>
                                                {
                                                    quote?.user &&
                                                    quote?.user?.userDetail &&
                                                    quote?.user?.userDetail?.benefits &&
                                                    JSON.parse(quote?.user?.userDetail?.benefits).map((benefit, index) => (
                                                        <div className='flex' key={index}>
                                                            <div className='w-[20px]'>
                                                                <FaCheck className='text-primary' />
                                                            </div>
                                                            <small className='sm:text-xs text-sm font-semibold mb-2'>
                                                                {benefit}
                                                            </small>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            <div className='flex flex-col items-center sm:ml-4'>
                                                <small className='inline-block font-semibold sm:mb-4 mb-2 sm:text-xs text-lg text-[#FF1D6A]'>
                                                    {
                                                        `${Math.round(quote?.distance) > 0 ?
                                                            quote?.distance.toFixed(2) :
                                                            0
                                                        } Miles Away`
                                                    }
                                                </small>
                                                <div className='mb-2 w-full flex flex-col items-center'>
                                                    <h2 className='sm:heading-2 heading-1 font-bold mb-4'>£{quote?.price}</h2>
                                                    <div
                                                        onClick={() => handleDecision(quote?.id)}
                                                        className='
                                                    w-full 
                                                    sm:py-3 
                                                    py-4 
                                                    p-3 
                                                    sm:text-xs 
                                                    text-lg
                                                    rounded-lg 
                                                    bg-[#02B563] 
                                                    text-white
                                                    text-center
                                                    cursor-pointer
                                                    '
                                                    >
                                                        Accept
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            )
                        }) : (
                            <div className='flex justify-center'>
                                <h6 className='heading-6 font-bold'>No Quotes Received</h6>
                            </div>
                        )
                }
            </Col>
            <Col span={24} className='md:px-20 sm:px-20 md:pt-6 sm:pt-6 px-2 pt-6'>
                <div className='px-2 py-4 bg-white rounded-md'>
                    <Pagination
                        defaultPageSize={5}
                        showSizeChanger
                        onShowSizeChange={onShowSizeChange}
                        current={currentPage}
                        total={totalItems}
                        pageSize={pageSize}
                        pageSizeOptions={[5, 10, 20, 50]}
                        onChange={onPageChange}
                    />
                </div>
            </Col>
        </Row>
    )
}

export default ReceivedQuotes